// 3rd party
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';

// bernie
import { ContextStore } from 'bernie-core';
import { ILocalization, LocalizedText, withLocalization } from '@shared-ui/localization-context';

// ui
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkHeading, UitkParagraph, UitkText } from 'uitk-react-text';
import { UitkTextArea } from 'uitk-react-input';
import { UitkPrimaryButton, UitkSecondaryButton } from 'uitk-react-button';
import { UitkLink } from 'uitk-react-link';
import { UserAuthStore, UserStore } from 'stores';
import { UitkIcon } from 'uitk-react-icons';
import { modifyLocaleParam } from '../../util/LocaleParamTransformer';
import ProgramStatus from 'stores/ProgramStatus';
import { UitkBanner } from 'uitk-react-banner';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { Program, ProgramRelationship } from 'models';

export interface VrboSearchProps {
  context?: ContextStore;
  l10n?: ILocalization;
  userAuth?: UserAuthStore;
  program?: Program;
}

@withLocalization
@inject('context', 'userAuth')
@observer
export class VrboSearch extends React.Component<VrboSearchProps, any> {
  private userProgramStatus;
  private candidateUserProgram;

  constructor(props) {
    super(props);

    this.candidateUserProgram = this.userProgramByBrandAndPosa(this.props.program);
    this.userProgramStatus = this.getUserProgramStatus(this.candidateUserProgram);
  }

  private copyToClipboardLabel = this.props.l10n.formatText('common.copy-to-clipboard');
  private copiedToClipboardLabel = this.props.l10n.formatText('common.copied-to-clipboard');

  public pasteToClipboard(copyText) {
    navigator.clipboard.writeText(copyText);

    const copyButton = document.getElementById('clipboardCopyBtn');
    copyButton.textContent = this.copiedToClipboardLabel;
    setTimeout(() => {
      copyButton.textContent = this.copyToClipboardLabel;
    }, 1500);
  }

  private userProgramByBrandAndPosa = (programDetails) => {
    const userProgramRelationships = this.props.userAuth.userProgramRelationships;
    const userInfo = this.props.userAuth.currentUser;
    const userId = userInfo && userInfo.email ? userInfo.email : null;

    let candidateUserProgram = null;
    if (userProgramRelationships && userProgramRelationships.body.filter) {
      candidateUserProgram = userProgramRelationships.body.filter((userProgramRelationship) => {
        return (
          userProgramRelationship.id.brand === programDetails.brand &&
          userProgramRelationship.id.posa === programDetails.posa &&
          userProgramRelationship.id.userId === userId
        );
      });
    }

    return candidateUserProgram;
  };

  private getUserProgramStatus(candidateUserProgram) {
    let programStatus = null;

    if (candidateUserProgram && candidateUserProgram.length) {
      const userProgram = candidateUserProgram[0];
      programStatus = userProgram.affiliatePartnership.partnershipStatus;
    } else {
      programStatus = null;
    }

    return programStatus;
  }

  private getUserCamRef = () => {
    if (this.candidateUserProgram && this.candidateUserProgram.length) {
      const userProgram = this.candidateUserProgram[0];

      return userProgram.programReference;
    }
  };

  private getLocalePath = (locale: string) => (locale !== 'en-us' ? `/${locale}` : '');

  private renderJoinNowBanner() {
    // This call doesn't work because there's something we're doing wrong with MobX
    // const currentRelationship = this.props.userAuth.getRelationshipForProgram(this.props.program)

    const pzSignUpPageLink = `/${modifyLocaleParam(this.props.context.locale)}/pz-signup?programName=${
      this.props.program.name
    }`;
    const programsPageLink = `/${modifyLocaleParam(this.props.context.locale)}/programs`;
    const productPageLink = `/${modifyLocaleParam(this.props.context.locale)}/products?programName=${
      this.props.program.name
    }`;
    const productPageLinkText = this.props.program.title;

    if (this.userProgramStatus === ProgramStatus.UNKNOWN || this.userProgramStatus == null) {
      return (
        <UitkSpacing margin={{ blockend: 'six' }}>
          <div>
            <UitkSpacing margin={{ blockend: 'four' }}>
              <div>
                <UitkBanner icon="info_outline" message={this.props.l10n.formatText('preview.products.banner.text')}>
                  <UitkLink inline={true}>
                    <Link to={pzSignUpPageLink} className="a--no-hover">
                      <LocalizedText message="preview.products.join.the.program" />
                    </Link>
                  </UitkLink>
                </UitkBanner>
              </div>
            </UitkSpacing>
            <UitkLayoutFlex justifyContent="space-between" alignItems="center">
              <UitkLayoutFlexItem>
                <UitkText>
                  <UitkLink inline={true}>
                    <Link to={programsPageLink} className="a--no-hover">
                      <LocalizedText message="programs.page.link" />
                    </Link>
                  </UitkLink>
                  &nbsp;{'>'}&nbsp;
                  <UitkLink inline={true}>
                    <Link to={productPageLink} className="a--no-hover">
                      {productPageLinkText}
                    </Link>
                  </UitkLink>
                  &nbsp;{'>'}
                </UitkText>
              </UitkLayoutFlexItem>
              <UitkLayoutFlexItem>
                <UitkPrimaryButton
                  type={'button'}
                  href={pzSignUpPageLink}
                  text={this.props.l10n.formatText('preview.products.join.the.program')}
                />
              </UitkLayoutFlexItem>
            </UitkLayoutFlex>
          </div>
        </UitkSpacing>
      );
    }
  }

  private renderDocumentationLink(locale: string) {
    return (
      <UitkSpacing margin={{ blockend: 'six' }}>
        <UitkParagraph size={1}>
          <UitkLink inline={true}>
            <a
              href={`https://www.vrbo.com${this.getLocalePath(locale)}/widgets/search-widget/documentation`}
              target="_blank"
            >
              <LocalizedText message="vrbo-search.getcode.implementation_guide" />
              <UitkIcon name="open_in_new" />
            </a>
          </UitkLink>
        </UitkParagraph>
      </UitkSpacing>
    );
  }

  private renderCodeMarkup(locale: string, camref: string) {
    camref = camref || 'INSERT-CAMREF-HERE';

    const codeMarkup =
      '<div' +
      ' class="ha-widget"' +
      ' data-site="vrbo"' +
      ` data-locale="${locale}"` +
      ' data-widget="search"' +
      ' data-layout="headlined"' +
      ' data-theme="lightgray"' +
      ' data-network="pz"' +
      ` data-camref="${camref}"` +
      ' data-pubref="INSERT-PUBREF-HERE"' +
      '></div>\n' +
      '<script' +
      ' class="ha-widget-script"' +
      ' src="https://csvcus.homeaway.com/rsrcs/cdn-affiliate-widgets/1.5.0/affiliate-widgets.min.js"' +
      '></script>';

    return <UitkTextArea id="searchWidgetCode" hasVisibleLabel={false} value={codeMarkup} />;
  }

  private renderPreviewFrame(locale: string, camref: string) {
    camref = camref || '';

    return (
      <>
        <link
          className="ha-widget-style"
          rel="stylesheet"
          href="https://csvcus.homeaway.com/rsrcs/cdn-affiliate-widgets/1.5.0/affiliate-widgets.min.css"
        />
        <div
          className="ha-widget ha-widget-search"
          data-site="vrbo"
          data-locale={locale}
          data-widget="search"
          data-layout="headlined"
          data-theme="lightgray"
          data-network="pz"
          data-camref={camref}
          data-pubref=""
        >
          <iframe
            className="ha-widget-frame"
            src={`https://www.vrbo.com${this.getLocalePath(
              locale,
            )}/widgets/search-widget?layout=headlined&theme=lightgray&network=pz&camref=${camref}&pubref=`}
          />
        </div>
        {/*<script*/}
        {/*  className="ha-widget-script"*/}
        {/*  src="https://csvcus.homeaway.com/rsrcs/cdn-affiliate-widgets/1.5.0/affiliate-widgets.min.js"*/}
        {/*/>*/}
      </>
    );
  }

  public render() {
    const { l10n, program } = this.props;

    const locale = modifyLocaleParam(program.locale);
    const camref = this.getUserCamRef();

    return (
      <UitkSpacing className="container" padding={{ block: 'twelve' }}>
        <main>
          {this.renderJoinNowBanner()}
          <UitkSpacing margin={{ small: { blockend: 'six' }, medium: { blockend: 'twelve' } }}>
            <UitkHeading tag="h1" size={2}>
              {this.props.program.title + ' ' + l10n.formatText('products.vrbo-search.title')}
            </UitkHeading>
          </UitkSpacing>
          <UitkLayoutGrid columns={{ large: 2 }} space="six">
            <UitkLayoutGridItem>
              <div>
                <UitkHeading tag="h4" size={4}>
                  <LocalizedText message="vrbo-search.getcode.title" />
                </UitkHeading>
                <UitkParagraph size={1}>
                  <LocalizedText message="vrbo-search.getcode.text" />
                </UitkParagraph>
                {this.renderDocumentationLink(locale)}
                {this.renderCodeMarkup(locale, camref)}
                <UitkParagraph size={1}>
                  <UitkSecondaryButton
                    id="clipboardCopyBtn"
                    onClick={() => {
                      const textArea = document.getElementById('searchWidgetCode') as HTMLTextAreaElement;
                      textArea.focus();
                      this.pasteToClipboard(textArea.value);
                    }}
                  >
                    {this.copyToClipboardLabel}
                  </UitkSecondaryButton>
                </UitkParagraph>
              </div>
            </UitkLayoutGridItem>
            <UitkLayoutGridItem>
              <div>
                <UitkHeading tag="h4" size={4}>
                  <LocalizedText message="vrbo-search.preview.title" />
                </UitkHeading>
                <UitkSpacing margin={{ blockend: 'six' }}>
                  <UitkParagraph size={1}>
                    <LocalizedText message="vrbo-search.preview.text" />
                  </UitkParagraph>
                </UitkSpacing>
                {this.renderPreviewFrame(locale, camref)}
              </div>
            </UitkLayoutGridItem>
          </UitkLayoutGrid>
        </main>
      </UitkSpacing>
    );
  }
}
